import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import MiniCartContainer from './Containers/MiniCart.container';
import QuickSearchContainer from './Containers/QuickSearch.container';

import NavigationContainer from './Containers/Navigation.container';
//import FacetedSearchContainer from './Containers/FacetedSearch.container';
//import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container';

import FacetedSearchContainer from './Columbus/Containers/FacetedSearch.container';
import OnlineCatalogSearchContainer from './Columbus/Containers/OnlineCatalogSearch.container';
import OnlineCatalog from './Columbus/Containers/OnlineCatalog.container';
import FacetedSearchCompactContainer from './Columbus/Containers/FacetedSearchCompact.container';

import NotificationContainer from './Containers/Notification.container';
import SelectOrganizationContainer from './Containers/SelectOrganization.container';
import DropZoneContainer from './Containers/DropZone.container';
import FavouritesContainer from './Containers/Favourites.container';
import ExportMenuContainer from './Containers/ExportMenu.container';
// Columbus 
import './columbus.events.js';
import WebsiteSelectorContainer from './Containers/WebsiteSelector.container';
import GenericExportContainer from './Containers/GenericExport.container';
// End Columbus
import DynamicComponent from './Components/DynamicComponent';

import tippy from './Vendor/tippy.js';
import Glide, { Breakpoints } from './Vendor/glide.js';
import { tns } from './vendor/TinySlider/tiny-slider.js';
import { get } from './Services/http';


let buyButtonsLoaded = false;
let BuyButton = null;
let FavouriteButton = null;

if (document.querySelectorAll('buy-button').length > 0) {
    BuyButton = DynamicComponent({
        loader: () => import('./Containers/BuyButton.Container')
    });
}

document.addEventListener("DOMContentLoaded", function () {
    tippy('.tooltip', {
        content: '',
        allowHTML: true,
        trigger: 'click',
        placement: 'bottom',
    });
});
document.addEventListener('click', function (event) {
    if (!event.target.matches('.show-persons-button')) return;
    event.preventDefault();
    const personWrapper = document.getElementById('person-wrapper');
    if (personWrapper) {
        personWrapper.classList.toggle('active');
    }

}, false);

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = window.__litium.store = window.__litium.store || (document.getElementById("orderTab") && window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));
window.__litium = {
    ...window.__litium,
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    initBuyButtons: () => {
        if (document.querySelectorAll('buy-button').length > 0) {
            BuyButton = DynamicComponent({
                loader: () => import('./Containers/BuyButton.Container')
            });
        }
        initBuyButtons();
    },
    cache: {}, // for storing cache data for current request
};

let slider = null;
let isDesktop = false;

function renderTinySlider() {

    let tinySlider = document.querySelectorAll('.tiny-slider');

    if (tinySlider.length != 0) {
        let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth < 1024) {
            isDesktop = false;
            slider = tns({
                container: '.tiny-slider',
                gutter: 10,
                items: 1,
                slideBy: 'page',
                controlsText: ['', ''],
                responsive: {
                    375: {
                        items: 2
                    },
                    640: {
                        items: 3
                    }
                }
            });
        }
        else {
            isDesktop = true;
            slider = tns({
                container: '.tiny-slider',
                gutter: 10,
                items: 3,
                axis: 'vertical',
                slideBy: 'page',
                controlsText: ['', '']
            });
        }
    }
}

function initLazyButton() {
    var lazyButton = document.getElementById('lazybutton');
    if (lazyButton) {
        lazyButton.addEventListener('click',
            function (event) {
                event.preventDefault();
                const href = lazyButton.getAttribute('href');
                fetchProducts(href, false, true);
                return false;
            }, false);
    }
}

window.addEventListener('popstate', (event) => {
    //console.log("POP");
    //console.log("event.state", event.state);
    if (event.state && event.state.lazy) {
        fetchProducts(window.location, true, false);
        //console.log("FETCH ALL");
    }
    //else{
    //    if (document.getElementsByClassName('product-list').length > 0) {

    //       //fetchProducts(window.location,false,false);
    //        console.log("FETCH");
    //    }
    //}
});

function fetchProducts(href, all, pushState) {
    var lazyButton = document.getElementById('lazybutton');
    lazyButton.classList.add("loading");
    const max = parseInt(lazyButton.getAttribute('data-max'));
    const _href = href.toString();

    fetch(_href + (_href.indexOf('?') !== -1 ? '&' : '?') + "lazy=true",
        {
            method: 'GET',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                'lazy': 'true',
                'all': all
            }
        })
        .then(response => response.text())
        .then(data => {
            const pageHtml = new DOMParser().parseFromString(data, 'text/html');
            const prodList = document.getElementsByClassName('product-list')[0];
            if (all || (!all && !pushState)) {
                prodList.innerHTML = '';
            }
            if (prodList) {
                get("/api/dataLayer")
                    .then(response => response.json())
                    .then(result => {
                        if (typeof result !== 'undefined' && result !== null)
                        {
                            gtag("event", "view_item_list", result);
                        }
                    });

                const childNodes = pageHtml.querySelectorAll('li');
                if (childNodes) {
                    for (let elem of childNodes) {
                        elem.classList.add('product-list__item--added');
                        prodList.appendChild(elem);
                    }

                    const newEls = document.querySelectorAll('.product-list__item--added');
                    for (let newEl of newEls) {
                        initBuyButtons(newEl);
                        initFavouriteButtons(newEl);

                        if (newEl.classList.contains("js-alternative-product")) {
                            initAlternativeProductClick(newEl);
                        }
                    }
                }
                const url = new URL(_href);
                const nextPage = getNextPage(url);
                url.searchParams.delete('lazy');
                lazyButton.classList.remove("loading");
                if (nextPage > max) {
                    lazyButton.style = "display:none";
                } else {
                    url.searchParams.set("page", nextPage);
                    lazyButton.setAttribute('href', decodeURIComponent(url));
                }
                if (pushState) {
                    window.history.pushState({ page: nextPage - 1 }, null, _href);
                }
            }
        });
}

function getNextPage(url) {
    var hasPage = url.searchParams.has("page");
    return hasPage ? parseInt(url.searchParams.get("page")) + 1 : 2;
}

function initBuyButton(button) {

    const { articleNumber, defaultQuantity, href, cssClass, packageLevels } = button.dataset;
    const label = button.innerText;
    ReactDOM.render(
        <Provider store={store}>
            <BuyButton {...{ label, articleNumber, defaultQuantity, href, cssClass, packageLevels }} />
        </Provider>,
        button
    );
}

function initBuyButtons(wrapperEl) {

    if (!wrapperEl) {
        wrapperEl = document.querySelector('body');
    }

    if (wrapperEl) {
        if (wrapperEl.querySelectorAll('buy-button').length > 0) {
            Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
                initBuyButton(button);
            });
        }
    }
}

function initFavouriteButtons(wrapperEl) {
    if (!wrapperEl) {
        wrapperEl = document.querySelector('body');
    }

    if (wrapperEl.querySelectorAll('favourite-button').length > 0) {
        const FavouriteButton = DynamicComponent({
            loader: () => import('./Containers/FavouriteButton.Container')
        });
        Array.from(wrapperEl.querySelectorAll('favourite-button')).forEach((button) => {
            const { articleNumber, favouriteClass, cssClass } = button.dataset;
            const label = button.innerText;
            ReactDOM.render(
                <Provider store={store}>
                    <FavouriteButton {...{ articleNumber, favouriteClass, cssClass }} />
                </Provider>,
                button
            );
        });
    }
}

function initAlternativeProduct(wrapperEl) {
    if (!wrapperEl) {
        wrapperEl = document.querySelector('body');
    }
    const alternativeProducts = wrapperEl.querySelectorAll('.js-alternative-product');

    if (alternativeProducts.length > 0) {
        for (let i = 0; i < alternativeProducts.length; i++) {
            initAlternativeProductClick(alternativeProducts[i]);
        }
    }
}

function initAlternativeProductClick(el) {
    el.addEventListener("click", function (event) {
        if (event.target.classList.contains("js-alternative-product-btn")) {
            el.classList.toggle("is-alternative");
        }
    });
}

window.addEventListener('resize', function () {
    let tinySlider = document.querySelectorAll('.tiny-slider');
    if (tinySlider.length != 0) {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if ((viewportWidth < 1024 && isDesktop) || (viewportWidth >= 1024 && !isDesktop)) {
            slider.destroy();
            renderTinySlider();
        }
    }
}, false);


window.addEventListener('load', function () {

    renderTinySlider();

    let gliderEls = document.querySelectorAll('.glider-custom');
    let newsPage = document.querySelector('.news-page');
    let conf;

    if (gliderEls) {
        const newsConf = {
            type: 'carousel',
            gap: 0,
            autoplay: 0,
            startAt: 0,
            perView: 2,
            bound: true,
            breakpoints: {
                1414: {
                    perView: 1
                }
            },
            animationDuration: 300,
            animationTimingFunc: 'ease-in-out',
        }
        const defaultConf = {
            type: 'carousel',
            gap: 0,
            autoplay: 0,
            startAt: 0,
            perView: 4,
            bound: true,
            breakpoints: {
                1024: {
                    perView: 2
                },
                640: {
                    perView: 1
                }
            },
            animationDuration: 300,
            animationTimingFunc: 'ease-in-out',
        }

        if (newsPage) {
            conf = newsConf;
        }
        else {
            conf = defaultConf;
        }
        //move.after
        for (var i = 0; i < gliderEls.length; i++) {

            const gl = new Glide(gliderEls[i], conf);
            gl.on('move.after',
                function () {
                    // Find all buy buttons
                    var buyButtonContainers = document.querySelectorAll('.glide__slide--clone');
                    for (var i = 0; i < buyButtonContainers.length; i++) {
                        const buyButtons = buyButtonContainers[i].getElementsByTagName('buy-button');
                        if (buyButtons) {
                            for (let buyButton of buyButtons) {
                                if (buyButton.classList && buyButton.classList.contains('react-mounted')) {
                                    return;
                                }
                                const { articleNumber, defaultQuantity, href, cssClass, packageLevels } =
                                    buyButton.dataset;
                                const label = buyButton.innerText;
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <BuyButton {...{ label, articleNumber, defaultQuantity, href, cssClass, packageLevels }} />
                                    </Provider>,
                                    buyButton
                                );
                                buyButton.classList.add('react-mounted');

                                // Adding Amount field
                            };
                        }
                    }
                });
            gl.mount();
        }
    }

    // Product thumbnail images
    let gliderThumbs = document.querySelectorAll('.product-detail__glider-thumbnails');
    const conf2 = {
        type: 'carousel',
        gap: 0,
        autoplay: 0,
        startAt: 0,
        perView: 3,
        bound: true,
        breakpoints: {
            1024: {
                perView: 4
            },
            640: {
                perView: 2
            }
        },
        animationDuration: 300,
        animationTimingFunc: 'ease-in-out'

    }

    gliderThumbs.forEach((gliderEl) => {
        const gl = new Glide(gliderEl, conf2);
        gl.on('move.after',
            function () {

                // Find all buy buttons
                var buyButtonContainers = document.querySelectorAll('.glide__slide--clone');
                if (buyButtonContainers) {
                    buyButtonContainers.forEach(
                        function (buyButtonContainer) {
                            const buyButtons = buyButtonContainer.getElementsByTagName('buy-button');
                            if (buyButtons) {
                                for (let buyButton of buyButtons) {
                                    if (buyButton.classList && buyButton.classList.contains('react-mounted')) {
                                        return;
                                    }
                                    initBuyButton(buyButton);

                                    buyButton.classList.add('react-mounted');
                                };
                            }
                        }
                    );
                }
            });
        gl.mount();
    });
});

const bootstrapComponents = () => {

    initLazyButton();

    // COLUMBUS FIELDS
    if (document.getElementById('genericExport')) {
        ReactDOM.render(
            <Provider store={store}>
                <GenericExportContainer />
            </Provider>,
            document.getElementById('genericExport')
        );
    }

    const onlineCatalog = document.getElementById('onlineCatalog');
    if (onlineCatalog) {
        ReactDOM.render(
            <Provider store={store}>
                <OnlineCatalog />
            </Provider>,
            onlineCatalog
        );
    }

    const createOrderPdfButton = document.querySelectorAll('.createOrderPdfButton');

    if (createOrderPdfButton.length > 0) {

        createOrderPdfButton.forEach((createPdfBtn, index) => {
            const options = {
                isOffer: createPdfBtn.dataset.isoffer.toLowerCase() === "true" || false,
                orderId: createPdfBtn.dataset.orderid || '',
            };

            const CreateOrderPdf = DynamicComponent({
                loader: () => import('./Components/CreateOrderPdf')
            });

            ReactDOM.render(
                <CreateOrderPdf options={options} />,
                createPdfBtn
            );
        });
    }

    // END COLUMBUS
    if (document.getElementById('miniCart')) {
        ReactDOM.render(
            <Provider store={store}>
                <MiniCartContainer />
            </Provider>,
            document.getElementById('miniCart')
        );
    }
    if (document.getElementById('quickSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <QuickSearchContainer />
            </Provider>,
            document.getElementById('quickSearch')
        );
    }
    if (document.getElementById('catalogSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <OnlineCatalogSearchContainer />
            </Provider>,
            document.getElementById('catalogSearch')
        );
    }

    if (document.getElementById('navbar')) {
        ReactDOM.render(
            <Provider store={store}>
                <NavigationContainer />
            </Provider>,
            document.getElementById('navbar')
        );
    }
    if (document.getElementById('websiteSelector')) {
        ReactDOM.render(
            <Provider store={store}>
                <WebsiteSelectorContainer />
            </Provider>,
            document.getElementById('websiteSelector')
        );
    }
    if (document.getElementById('facetedSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchContainer />
            </Provider>,
            document.getElementById('facetedSearch')
        );
    }
    if (document.getElementById('facetedSearchCompact')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchCompactContainer />
            </Provider>,
            document.getElementById('facetedSearchCompact')
        );
    }
    if (document.getElementById('globalNotification')) {
        ReactDOM.render(
            <Provider store={store}>
                <NotificationContainer />
            </Provider>,
            document.getElementById('globalNotification')
        );
    }

    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Containers/PersonList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <PersonList />
            </Provider>,
            document.getElementById('myPagePersons')
        );
    }
    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Containers/AddressList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <AddressList />
            </Provider>,
            document.getElementById('myPageAddresses')
        );
    }
    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Containers/Checkout.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <Checkout />
            </Provider>,
            document.getElementById('checkout')
        );
    }

    if (document.getElementById('lightBoxImages')) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./Containers/LightboxImages.container')
        });
        const rootElement = document.getElementById('lightBoxImages');
        const rootElementVideos = document.getElementById('lightBoxVideos');
        const images = Array.from(rootElement.querySelectorAll('a')).map(img => (img.dataset.src));
        const videos = Array.from(rootElementVideos.querySelectorAll('span a')).map(a => (a.href));
        const concatArray = images.concat(videos);

        const images2 = Array.from(rootElement.querySelectorAll('a')).map(img => ({ src: img.dataset.src, type: "image" }));
        const videos2 = Array.from(rootElementVideos.querySelectorAll('span a')).map(a => ({ src: a.getAttribute("data-image"), type: "video" }));

        const thumbnails = Array.from(rootElement.querySelectorAll('a img')).map(img => ({ src: img.src, alt: img.alt, type: "image" }));
        const concatArray2 = thumbnails.concat(videos2);



        const concat = images.concat(videos);
        ReactDOM.render(
            <Provider store={store}>
                <LightboxImages thumbnails={concatArray2} videos={videos2} items={concatArray} />
            </Provider>,
            document.getElementById('lightBoxImages')
        );
    }

    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/Slider')
        });
        Array.from(document.querySelectorAll('.slider')).forEach((slider, index) => {
            const values = [...slider.querySelectorAll('.slider__block')].map(block => {

                let textbelowmobile = false;
                if (block.dataset.textbelowmobile.toLowerCase() === 'true') {
                    textbelowmobile = true;
                }

                let textstyle = { color: "inherit" };
                let textStyleString = block.dataset.textstyle + ' ' + block.dataset.ctastyle;
                textstyle = returnAsObject(textStyleString);

                let headersizecss = { color: "inherit" };
                let headersizecssString = block.dataset.headersizecss;
                headersizecss = returnAsObject(headersizecssString);

                return ({
                    image: block.dataset.image,
                    url: block.dataset.url,
                    text: block.dataset.text,
                    tabletimageurl: block.dataset.tabletimageurl,
                    mobileimageurl: block.dataset.mobileimageurl,
                    bannerimageclassdesktop: "slider__image " + block.dataset.bannerimageclassdesktop,
                    bannerimageclasstablet: "slider__image " + block.dataset.bannerimageclasstablet,
                    blocktitle: block.dataset.blocktitle,
                    blocktext: block.dataset.blocktext,
                    textstyle: textstyle,
                    ctastyle: block.dataset.ctastyle,
                    headersizecss: headersizecss,
                    textbelowmobile: textbelowmobile,
                })
            });
            if (values.length > 0) {
                ReactDOM.render(
                    <Slider values={values} />,
                    slider
                );
            }
        });
    }

    initBuyButtons();
    initFavouriteButtons();
    initAlternativeProduct();

    if (document.querySelectorAll('reorder-button').length > 0) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Containers/ReorderButton.Container')
        });
        Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
            const { cssClass, orderId, title } = button.dataset;
            const label = button.innerText;
            ReactDOM.render(
                <Provider store={store}>
                    <ReorderButton {...{ label, title, cssClass, orderId }} />
                </Provider>,
                button
            );
        });
    }

    const cookieBar = document.getElementById('cookieBar');
    if (cookieBar) {
        const CookieWarning = DynamicComponent({
            loader: () => import('./Columbus/Components/CookieBar')
        });
        ReactDOM.render(
            <Provider store={store}>
                <CookieWarning {...{ cookiebarVisible: true }} />
            </Provider>,
            cookieBar
        )
    }

    const cookieButton = document.getElementById('cookieButton');
    if (cookieButton) {
        const CookieSettings = DynamicComponent({
            loader: () => import('./Columbus/Components/CookieBar')
        });
        const { functional, analytics, marketing } = cookieButton.dataset;
        ReactDOM.render(
            <Provider store={store}>
                <CookieSettings {...{ showButton: true, functional, analytics, marketing }} />
            </Provider>,
            cookieButton
        )
    }
    if (document.getElementById('selectOrganization')) {
        ReactDOM.render(
            <Provider store={store}>
                <SelectOrganizationContainer showFullForm={true} />
            </Provider>,
            document.getElementById('selectOrganization')
        );
    }

    if (document.getElementById('dropzone')) {
        ReactDOM.render(
            <Provider store={store}>
                <DropZoneContainer />
            </Provider>,
            document.getElementById('dropzone')
        );
    }
    if (document.getElementById('mobile-dropzone')) {
        ReactDOM.render(
            <Provider store={store}>
                <DropZoneContainer {...{ mobile: true }} />
            </Provider>,
            document.getElementById('mobile-dropzone')
        );
    }
    if (document.getElementById('favourites')) {
        ReactDOM.render(
            <Provider store={store}>
                <FavouritesContainer />
            </Provider>,
            document.getElementById('favourites')
        );
    }
    if (document.getElementById('mobile-favourites')) {
        ReactDOM.render(
            <Provider store={store}>
                <FavouritesContainer {...{ mobile: true }} />
            </Provider>,
            document.getElementById('mobile-favourites')
        );
    }
    if (document.getElementById('exportmenu')) {
        ReactDOM.render(
            <Provider store={store}>
                <ExportMenuContainer />
            </Provider>,
            document.getElementById('exportmenu')
        );
    }
    if (document.getElementById('mobile-exportmenu')) {
        ReactDOM.render(
            <Provider store={store}>
                <ExportMenuContainer {...{ mobile: true }} />
            </Provider>,
            document.getElementById('mobile-exportmenu')
        );
    }

    const datalayerPreloadScripts = document.getElementsByClassName('datalayer-preload');
    if (datalayerPreloadScripts && datalayerPreloadScripts.length > 0 && window.__datalayerPreload) {
        for (const datalayerPreloadScript of datalayerPreloadScripts) {
            const gtagEvent = datalayerPreloadScript.dataset["event"];
            const view = datalayerPreloadScript.dataset["view"];
            const searchParams = new URLSearchParams();
    
            switch(view) {
                case "VariantsView":
                    if (window.__datalayerPreload.products.length == 0) {
                        continue;
                    }
                    
                    window.__datalayerPreload.products.forEach(id => searchParams.append("variantId", id));
                    delete window.__datalayerPreload.products;
                    break;
                case "VariantProductPage":
                    searchParams.append("variantId", window.__datalayerPreload.variantId);
                    delete window.__datalayerPreload.variantId;
                    break;
                default:
                    continue;
            }
    
            get(`/api/datalayer/${view}?${searchParams.toString()}`)
            .then(async (res) => await res.json())
            .then((data) => {
                gtag("event", gtagEvent, data);
            });
        }
    }
}

bootstrapComponents();


function returnAsObject(str) {
    var textstyle = { fontWeight: "normal" };
    if (str.length > 5) {
        textstyle = '{' + str + '}';
        textstyle = textstyle.replace(",}", "}").replace(/'/g, '"');
        try {
            return JSON.parse(textstyle);
        }
        catch (err) {
            return { fontWeight: "normal" };
        }
    }
}
